import { createContentBlock, createSubContent } from "@/lib/text-utils";

export const content = [
  // Introduction
createContentBlock(
    "introduction",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">Wireless World ("we," "our," or "us"), located at 16141 Leadwell Street, Van Nuys, CA 91406, USA, is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you engage with our business, including through our website, mobile applications, and physical retail locations (collectively, the "Services").</p>
        <p>PLEASE READ THIS PRIVACY POLICY CAREFULLY. BY ACCESSING OR USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS PRIVACY POLICY. IF YOU DO NOT AGREE WITH OUR POLICIES AND PRACTICES, PLEASE DO NOT USE OUR SERVICES.</p>
      `,
        sectionId: "1",
      }),
    ],
    undefined,
    1
  ),

  // Information We Collect
  createContentBlock(
    "information we collect",
    "We collect information in various ways depending on how you interact with our Services:",
    [
      createSubContent({
        title: "Personal Information You Provide to Us",
        content:
          "We may collect the following categories of personal information that you voluntarily provide to us:",
        listItems: [
          "Identification Information: Name, email address, postal address, phone number, account username and password",
          "Financial Information: Credit/debit card numbers, banking information, and billing addresses",
          "Commercial Information: Products or services purchased, obtained, or considered",
          "Professional Information: Company name, title, and business contact information",
          "Communications: Information you provide when you contact our customer service",
          "User Content: Reviews, ratings, feedback, and survey responses",
        ],
        sectionId: "2",
        subSectionId: "1",
      }),
      createSubContent({
        title: "Information We Collect Automatically",
        content:
          "When you use our Services, we may automatically collect certain information, including:",
        listItems: [
          "Technical Information: IP address, device type, browser type and version, operating system, language preferences, time zone setting, and screen resolution",
          "Usage Information: Pages visited, time spent on pages, links clicked, search queries, referring website addresses, and feature usage patterns",
          "Location Information: Approximate location derived from IP address or precise location (with your consent)",
          "Transaction Information: Products purchased, dates, times, and amounts of purchases",
          "Behavioral Information: Browsing history, search history, and interactions with advertisements",
        ],
        sectionId: "2",
        subSectionId: "2",
      }),
      createSubContent({
        title: "Information from Third Parties",
        content: "We may receive information about you from third parties, including:",
        listItems: [
          "Business partners, distributors, and manufacturers with whom we collaborate",
          "Payment processors and financial institutions",
          "Analytics providers and advertising networks",
          "Social media platforms when you interact with our social media presence or use social media credentials to log in to our Services",
          "Public databases and commercially available sources",
        ],
        sectionId: "2",
        subSectionId: "3",
      }),
      createSubContent({
        title: "Cookies and Similar Technologies",
        html: `
          <p class="mb-4">We and our third-party service providers use cookies, web beacons, pixel tags, and similar technologies to collect information about your browsing activities. These technologies help us analyze trends, administer the website, track users' movements around the website, and gather demographic information about our user base as a whole.</p>
          <p class="mb-4">You can control cookies through your browser settings and other tools. However, if you block certain cookies, you may not be able to register, log in, or access certain parts or make full use of the Services.</p>
          <p>For more details about our use of cookies and similar technologies, please refer to our Cookie Policy.</p>
        `,
        sectionId: "2",
        subSectionId: "4",
      }),
    ],
    undefined,
    2
  ),

  // How We Use Your Information
  createContentBlock(
    "how we use your information",
    "We use the information we collect for various business and commercial purposes, including to:",
    [
      createSubContent({
        title: "Provide and Maintain Our Services",
        listItems: [
          "Process and fulfill orders, transactions, and other purchases",
          "Register and maintain your account",
          "Provide customer support and respond to inquiries",
          "Send service-related communications",
          "Authenticate users and verify identity",
        ],
        sectionId: "3",
        subSectionId: "1",
      }),

      createSubContent({
        title: "Improve and Develop Our Services",
        listItems: [
          "Analyze usage patterns and trends",
          "Conduct research and development",
          "Debug to identify and repair errors",
          "Enhance user experience and develop new features",
          "Test and evaluate new offerings and functionalities",
        ],
        sectionId: "3",
        subSectionId: "2",
      }),

      createSubContent({
        title: "Personalize Your Experience",
        listItems: [
          "Customize content and product recommendations",
          "Remember your preferences and settings",
          "Provide personalized marketing communications",
          "Offer targeted promotions and advertisements",
        ],
        sectionId: "3",
        subSectionId: "3",
      }),

      createSubContent({
        title: "Marketing and Advertising",
        listItems: [
          "Send promotional communications about products, services, offers, and events",
          "Deliver targeted advertising on our Services and other websites",
          "Measure the effectiveness of our marketing and advertising campaigns",
          "Manage and serve ads based on your interests and browsing behavior",
        ],
        sectionId: "3",
        subSectionId: "4",
      }),

      createSubContent({
        title: "Security and Protection",
        listItems: [
          "Protect against fraudulent, unauthorized, or illegal activity",
          "Enforce our Terms of Service and other legal rights",
          "Debug to identify and repair errors that impair existing functionality",
          "Verify identity and prevent fraud",
          "Ensure the security of our Services",
        ],
        sectionId: "3",
        subSectionId: "5",
      }),

      createSubContent({
        title: "Compliance and Business Operations",
        listItems: [
          "Comply with legal obligations, including responding to law enforcement requests",
          "Conduct auditing related to interactions with consumers",
          "Carry out our obligations and enforce our rights arising from any contracts",
          "Evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets",
        ],
        sectionId: "3",
        subSectionId: "6",
      }),
    ],
    undefined,
    3
  ),

  // 4. How We Share Your Information (move this here, before Data Security)
  createContentBlock(
    "how we share your information",
    "We may share your information with the following categories of third parties:",
    [
      createSubContent({
        title: "Service Providers",
        content:
          "We share information with third-party vendors and service providers who perform services on our behalf, such as payment processing, order fulfillment, data analysis, email delivery, hosting services, customer service, and marketing assistance.",
        sectionId: "4",
        subSectionId: "1",
      }),

      createSubContent({
        title: "Business Partners",
        content:
          "We may share information with our business partners, including manufacturers, distributors, and retailers, to offer certain products, services, or promotions.",
        sectionId: "4",
        subSectionId: "2",
      }),

      createSubContent({
        title: "Affiliates and Subsidiaries",
        content:
          "We may share information with our affiliated and subsidiary companies for business purposes such as internal administration, promoting our products or services, and providing you with information about other products and services we offer.",
        sectionId: "4",
        subSectionId: "3",
      }),

      createSubContent({
        title: "Advertising Partners",
        content:
          "We share information with third-party advertisers and advertising networks to deliver relevant advertisements on our Services and on third-party websites.",
        sectionId: "4",
        subSectionId: "4",
      }),

      createSubContent({
        title: "Analytics Providers",
        content:
          "We share information with analytics providers who help us understand how customers use our Services.",
        sectionId: "4",
        subSectionId: "5",
      }),

      createSubContent({
        title: "Social Media Platforms",
        content:
          "If you choose to connect your social media accounts to our Services or interact with our social media presence, we may share information with those social media platforms.",
        sectionId: "4",
        subSectionId: "6",
      }),

      createSubContent({
        title: "Legal Compliance and Protection",
        content: "We may disclose information:",
        listItems: [
          "To comply with any court order, law, or legal process, including responding to any government or regulatory request",
          "To enforce or apply our Terms of Service and other agreements",
          "If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Wireless World, our customers, or others",
        ],
        sectionId: "4",
        subSectionId: "7",
      }),

      createSubContent({
        title: "Business Transfers",
        content:
          "In the event of a merger, acquisition, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of our assets, your information may be transferred as part of that transaction.",
        sectionId: "4",
        subSectionId: "8",
      }),

      createSubContent({
        title: "With Your Consent",
        content: "We may disclose your information for any other purpose with your consent.",
        sectionId: "4",
        subSectionId: "9",
      }),
    ],
    undefined,
    4
  ),

  createContentBlock(
    "your privacy rights and choices",
    "Depending on your jurisdiction, you may have certain rights regarding your personal information. These rights may include:",
    [
      createSubContent({
        title: "Access and Portability",
        content:
          "You may have the right to request access to the personal information we have collected about you, including the categories of information, sources, purposes of collection, and categories of third parties with whom we share it.",
        sectionId: "5",
        subSectionId: "1",
      }),

      createSubContent({
        title: "Correction",
        content:
          "You may have the right to request that we correct inaccurate personal information we maintain about you.",
        sectionId: "5",
        subSectionId: "2",
      }),

      createSubContent({
        title: "Deletion",
        content:
          "You may have the right to request deletion of your personal information, subject to certain exceptions.",
        sectionId: "5",
        subSectionId: "3",
      }),

      createSubContent({
        title: "Opt-Out of Sale or Sharing",
        content:
          "Where applicable, you may have the right to opt-out of the sale or sharing of your personal information for cross-context behavioral advertising.",
        sectionId: "5",
        subSectionId: "4",
      }),

      createSubContent({
        title: "Non-Discrimination",
        content: "We will not discriminate against you for exercising any of your privacy rights.",
        sectionId: "5",
        subSectionId: "5",
      }),

      createSubContent({
        title: "Marketing Communications",
        content:
          "You can opt out of receiving our marketing communications by following the unsubscribe instructions included in such communications or by contacting us.",
        sectionId: "5",
        subSectionId: "6",
      }),

      createSubContent({
        title: "How to Exercise Your Rights",
        content:
          'To exercise your rights, please contact us using the information provided in the "Contact Us" section below. We may need to verify your identity before responding to your request.',
        sectionId: "5",
        subSectionId: "7",
      }),
    ],
    undefined,
    5
  ),

  // Data Retention
  createContentBlock(
    "data retention",
    "",
    [
      createSubContent({
        title: "",
        html: `
          <p class="mb-4">We retain your personal information for as long as necessary to fulfill the purposes for which we collected it, including for the purposes of satisfying any legal, accounting, or reporting requirements, to establish or defend legal claims, or for fraud prevention purposes.</p>
          <p>When we no longer need to retain your personal information, we will delete or anonymize it. If this is not possible (for example, because your personal information has been stored in backup archives), we will securely store your personal information and isolate it from any further processing until deletion is possible.</p>
        `,
        sectionId: "6",
        subSectionId: "1",
      }),
    ],
    undefined,
    6
  ),

  // Data Security
  createContentBlock(
    "data security",
    "",
    [
      createSubContent({
        title: "",
        html: `
          <p class="mb-4">We have implemented appropriate technical and organizational measures to protect the security of your personal information. However, please understand that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.</p>
          <p>In the event of a data breach that is likely to result in a high risk to your rights and freedoms, we will notify you and the relevant supervisory authority in accordance with applicable law.</p>
        `,
        sectionId: "7",
        subSectionId: "1",
      }),
    ],
    undefined,
    7
  ),

  createContentBlock(
    "international data transfers",
    "",
    [
      createSubContent({
        title: "",
        html: `
          <p class="mb-4">We may transfer your personal information to countries other than the country in which you initially provided the information for the purposes described in this Privacy Policy. If we transfer your personal information to countries outside of your jurisdiction, we will ensure that appropriate safeguards are in place to protect your personal information in accordance with this Privacy Policy and applicable law.</p>
          <p class="mb-4">These safeguards may include:</p>
        `,
        sectionId: "8",
        subSectionId: "1",
      }),
      createSubContent({
        title: "",
        listItems: [
          "Transferring to countries that have been deemed to provide an adequate level of protection for personal data",
          "Using specific contracts approved by relevant authorities that give personal data the same protection it has in your jurisdiction",
          "Implementing corporate rules that ensure adequate levels of protection for international transfers within our corporate group",
        ],
        sectionId: "8",
        subSectionId: "2",
      }),
    ],
    undefined,
    8
  ),

  // Children's Privacy
  createContentBlock(
    "children's privacy",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p>Our Services are not directed to children under 16 years of age, and we do not knowingly collect personal information from children under 16. If we learn we have collected or received personal information from a child under 16 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 16, please contact us.</p>
      `,
        sectionId: "9",
        subSectionId: "1",
      }),
    ],
    undefined,
    9
  ),

  // Third-Party Websites
  createContentBlock(
    "third-party websites and services",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p>Our Services may contain links to third-party websites, applications, or services that are not owned or controlled by Wireless World. This Privacy Policy applies only to our Services. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party websites or services. We encourage you to review the privacy policies of any third-party websites or services that you visit.</p>
      `,
        sectionId: "10",
        subSectionId: "1",
      }),
    ],
    undefined,
    10
  ),

  createContentBlock(
    "changes to this privacy policy",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on our website with an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.</p>
        <p>For material changes, we will take reasonable steps to notify you, such as by posting a prominent notice on our website or sending you an email notification. Your continued use of our Services after any changes to this Privacy Policy constitutes your acceptance of such changes.</p>
      `,
        sectionId: "11",
        subSectionId: "1",
      }),
    ],
    undefined,
    11
  ),

  createContentBlock(
    "specific jurisdictional provisions",
    "",
    [
      createSubContent({
        title: "California Residents",
        html: `
          <p>If you are a California resident, you have specific rights under the California Consumer Privacy Act (CCPA) and the California Privacy Rights Act (CPRA). For more information about these rights and how to exercise them, please see our <a href="/california-privacy-notice" class="text-system-primary hover:underline">California Privacy Notice</a>.</p>
        `,
        sectionId: "12",
        subSectionId: "1",
      }),

      createSubContent({
        title: "Nevada Residents",
        content:
          'Nevada residents have the right to opt out of the sale of certain "covered information" collected by operators of websites or online services. We do not sell your covered information as defined in Nevada law.',
        sectionId: "12",
        subSectionId: "2",
      }),

      createSubContent({
        title: "12.3 European Economic Area, United Kingdom, and Switzerland",
        html: `
          <p>If you are in the European Economic Area (EEA), United Kingdom (UK), or Switzerland, you have certain rights under applicable data protection laws, including the General Data Protection Regulation (GDPR). For more information about these rights and how to exercise them, please see our <a href="/gdpr" class="text-system-primary hover:underline">GDPR Privacy Notice</a>.</p>
        `,
        sectionId: "12",
        subSectionId: "3",
      }),

      createSubContent({
        title: "12.4 Canada",
        content:
          'If you are a resident of Canada, you have certain rights under the Personal Information Protection and Electronic Documents Act (PIPEDA) and provincial privacy laws. These rights may include access, correction, and withdrawal of consent. To exercise these rights, please contact us using the information provided in the "Contact Us" section.',
        sectionId: "12",
        subSectionId: "4",
      }),
    ],
    undefined,
    12
  ),

  createContentBlock(
    "supplemental privacy notices",
    "",
    [
      createSubContent({
        title: "13.1 Online Tracking and Do Not Track Signals",
        content:
          'Some browsers offer a "Do Not Track" feature that signals to websites that you do not want to have your online activities tracked. We currently do not respond to Do Not Track signals because there is not yet a common understanding of how to interpret these signals. However, you can usually choose to disable cookies or adjust your tracking preferences through your browser settings.',
        sectionId: "13",
        subSectionId: "1",
      }),

      createSubContent({
        title: "13.2 Mobile Device Privacy",
        content:
          "When you download, access, or use our mobile applications, we may receive information about your mobile device, including a unique identifier for your device. We may use this information to provide you with personalized content and advertising, and to analyze the usage of our applications. You can stop all collection of information by our mobile applications by uninstalling them.",
        sectionId: "13",
        subSectionId: "2",
      }),

      createSubContent({
        title: "13.3 IoT and Connected Devices",
        content:
          "If you purchase or use our connected devices or Internet of Things (IoT) products, we may collect additional information, such as device identifiers, usage data, and location data. This information helps us improve our products and provide you with related services. You can manage the collection of this information through the device settings or related mobile applications.",
        sectionId: "13",
        subSectionId: "3",
      }),

      createSubContent({
        title: "13.4 Biometric Information",
        content:
          "We do not currently collect biometric information (such as fingerprints, facial recognition, or voiceprints) through our Services. If this changes in the future, we will update this Privacy Policy and obtain appropriate consent in accordance with applicable laws.",
        sectionId: "13",
        subSectionId: "4",
      }),

      createSubContent({
        title: "13.5 Employee and Applicant Privacy",
        content:
          "If you are an employee or applicant of Wireless World, please note that different privacy notices may apply to you. Please contact our Human Resources department for more information.",
        sectionId: "13",
        subSectionId: "5",
      }),
    ],
    undefined,
    13
  ),

  createContentBlock(
    "contact us",
    "",
    [
      createSubContent({
        title: "",
        html: `
        <p class="mb-4">If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us at:</p>
        <p class="mb-4">Wireless World<br>16141 Leadwell Street<br>Van Nuys, CA 91406, USA</p>
        <p class="mb-4">Email:<br><a href="mailto:privacy@wirelessworld.us" class="text-system-primary hover:underline">privacy@wirelessworld.us</a></p>
        <p class="mb-4">Phone:<br><a href="tel:+18182858209" class="text-system-primary hover:underline">+1 (818) 285 8209</a></p>
        <p>By using our Services, you acknowledge that you have read and understood this Privacy Policy.</p>
      `,
        sectionId: "14",
        subSectionId: "1",
      }),
    ],
    undefined,
    14
  ),
];
